import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl, FormArray, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {EnumData} from "../../../../api/enum/enum.model";
import {Course} from "../../../../api/models/program.model";

@Component({
    selector: 'app-siblings-section',
    imports: [ReactiveFormsModule],
    templateUrl: './siblings-section.component.html'
})
export class SiblingsSectionComponent {
    @Input() formArray!: FormArray;
    @Input() allCourses: Course[] = [];
    @Input() siblingRelationType: EnumData[] = [];
    @Output() add = new EventEmitter<void>();
    @Output() remove = new EventEmitter<number>();

    asFormGroup(control: AbstractControl): FormGroup {
        return control as FormGroup;
    }
}
